module.exports = __webpack_public_path__ + "img/login.dfecf63a.png";